import React from "react";

// classes base compartilhadas por todos os campos do painel (inputs, selects e textareas).
// text-base no mobile evita o zoom automático do iOS ao focar o campo.
export const adminInputClass = "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base md:text-sm text-gray-900 placeholder:text-gray-400 outline-none transition focus:border-gray-900 focus:ring-2 focus:ring-secondary/30 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed";

export default function AdminTextInput({
    value,
    onChange,
    placeholder,
    disabled = false,
    type = "text",
    onEnter,
    id,
    className = "",
    inputMode,
    autoComplete = "off"
}: {
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    type?: string;
    onEnter?: () => void;
    id?: string;
    className?: string;
    inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
    autoComplete?: string;
}) {
    return (
        <input
            id={id}
            disabled={disabled}
            className={`${adminInputClass} h-10 ${className}`}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            inputMode={inputMode}
            autoComplete={autoComplete}
            onKeyDown={onEnter ? e => { if (e.key === "Enter" && !disabled) { e.preventDefault(); onEnter(); } } : undefined}
        />
    )
}
